import { useCallback, useSyncExternalStore } from "react";

import { DisplayZone, ResolvedDateTimeFormat } from "./format";
import { getActiveDateTimeFormat, subscribeDateTimeFormat } from "./registry";

/**
 * React hook returning the active resolved date/time formatter. Components
 * that format dates inline should use this so they re-render when the user
 * changes their preference. Backed by the same registry the pure
 * `formatters` read, via `useSyncExternalStore`, so it works regardless of
 * provider nesting (defaults to the locale format before config loads).
 *
 * Pass `zone` to read every instant on that clock instead of the viewer's
 * local one (a Local/UTC toggle); the preference still decides the style.
 */
export function useDateTimeFormat(zone?: DisplayZone): ResolvedDateTimeFormat {
  const getSnapshot = useCallback(() => getActiveDateTimeFormat(zone), [zone]);
  return useSyncExternalStore(
    subscribeDateTimeFormat,
    getSnapshot,
    getSnapshot,
  );
}
